export const VERSION = 'dev';
